import {
    SHOW_SUCCESSFUL_MESSAGE,
    SHOW_INFO_MESSAGE,
    SHOW_WARNING_MESSAGE,
    SHOW_ERROR_MESSAGE,
    LOGGED_IN_MESSAGE,
    UPDATE_SHOW_LOADING,
    USER_LOGOUT,
    ON_NOTIFICATION_RECEIVED,
    ON_USER_PICTURE_CHANGE,
    ON_ROUTE_CHANGE,
    UPDATE_SHOW_MESSAGE
} from 'reducers/constants';

const initialState = {
    message: {
        show: false,
        type: "",
        text: "",
        icon: ""
    },
    dashboard: {
        scrollToTop: null,
        showLoading: false
    },
    showLoggedInMessage: false,
    currentRoute: null
}

export default function (state = initialState, action) {
    switch (action.type) {
        case SHOW_SUCCESSFUL_MESSAGE:
            return {
                ...state,
                message: {
                    show: true,
                    type: "success",
                    text: action.payload
                }
            }

        case SHOW_INFO_MESSAGE:
            return {
                ...state,
                message: {
                    show: true,
                    type: "info",
                    text: action.payload
                }
            }

        case SHOW_WARNING_MESSAGE:
            return {
                ...state,
                message: {
                    show: true,
                    type: "warning",
                    text: action.payload
                }
            }

        case SHOW_ERROR_MESSAGE:
            return {
                ...state,
                message: {
                    show: true,
                    type: "error",
                    text: action.payload
                }
            }

        case LOGGED_IN_MESSAGE:
            return {
                ...state,
                showLoggedInMessage: action.payload
            }

        case UPDATE_SHOW_LOADING: {
            state.dashboard.showLoading = action.payload;
            let newDashboard = Object.assign({}, state.dashboard);
            return {
                ...state,
                dashboard: newDashboard
            }
        }

        case UPDATE_SHOW_MESSAGE: {
            state.message.show = action.payload;
            let newMessage = Object.assign({}, state.message);
            return {
                ...state,
                message: newMessage
            }
        }

        case ON_NOTIFICATION_RECEIVED: {
            return {
                ...state,
                notification: action.payload
            }
        }

        case ON_ROUTE_CHANGE: {
            return {
                ...state,
                currentRoute: action.payload
            }
        }

        case ON_USER_PICTURE_CHANGE: {
            return {
                ...state,
                userPicture: action.payload
            }
        }

        default:
            return state;

    }
}


// WEBPACK FOOTER //
// ./src/reducers/application/applicationReducer.js